<template>
  <vs-popup class="predicted-graph-popup"
            id="popup"
            :title="data ? data.company_product_code + '-'+ data.category.prefix + ' | ' + data.company_product_name : ''"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <div class="vx-row">
        <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="BoxIcon"
            icon-right
            :statistic="data ? parseFloat(data.current_stock_level).toFixed(2) : '0'"
            statisticTitle="Stock Level (kg)" />
        </div>
        <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="AlertOctagonIcon"
            icon-right
            :statistic="data? parseFloat(data.total_order_quantity_not_manufactured).toFixed(2) : '0'"
            statisticTitle="Total SO QTY Needed (kg)" />
        </div>
        <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="Maximize2Icon"
            icon-right
            :statistic="data ? parseFloat(data.shortfall_surplus).toFixed(2) : '0'"
            statisticTitle="Shortfall/Surplus (kg)" />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-full">
          <vx-card :title="'VS-TOTAL ORDERS/RM QTY ALLOCATED TO CUSTOMER ORDERS - ' + rmUseOrderBarChartOptions.xaxis.categories.length + ' Days'" no-shadow>
            <div class="vx-row flex-col-reverse md:flex-col-reverse sm:flex-row lg:flex-row">
            </div>
            <div class="row" v-if="isLoaded">
              <div class="vx-col w-full md:w-full sm:w-full lg:w-full xl:w-full flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base">
                <vue-apex-charts type="bar" height="500" :options="rmUseOrderBarChartOptions" :series="clientRetentionBar.series" />
              </div>
            </div>
          </vx-card>
        </div>
<!--        <div class="vx-col w-full md:w-1/2">-->
<!--          <vx-card :title="'VS-TOTAL QUANTITY- ' + rmUseQuantityBarChartOptions.xaxis.categories.length + ' Days'" no-shadow>-->
<!--            <div class="vx-row flex-col-reverse md:flex-col-reverse sm:flex-row lg:flex-row">-->
<!--            </div>-->
<!--            <div class="row" v-if="isLoaded">-->
<!--              <div class="vx-col w-full md:w-full sm:w-full lg:w-full xl:w-full flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base">-->
<!--                <vue-apex-charts type="bar" height="500" :options="rmUseQuantityBarChartOptions" :series="clientRetentionBar.series1" />-->
<!--              </div>-->
<!--            </div>-->
<!--          </vx-card>-->
<!--        </div>-->
      </div>

    </vx-card>
  </vs-popup>
</template>

<script>
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import VueApexCharts from 'vue-apexcharts'
  import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
  import moment from 'moment';

  function initialState() {
    return {
      open: false,
      id: '',
      isLoaded :false,
      orders_arr: [],
      rmUseOrderBarChartOptions: {
        grid: {
          borderColor: '#ebebeb',
          padding: {
            left: 0,
            right: 0
          }
        },
        legend: {
          seriesName: 'sdfdsfdsf',
          show: false,
        },
        dataLabels: {
          enabled: true,
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: [ '#AA2EE6', '#ffb921']
          }
        },
        chart: {
          stacked: true,
          type: 'bar',
          toolbar: { show: true }
        },
        colors: [ '#AA2EE6' ,'#ffb921'],
        plotOptions: {
          bar: {
            columnWidth: '25%',
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          }
        },
        xaxis: {
          labels: {
            rotate: -45,
            rotateAlways: true,
            style: {
              cssClass: 'text-grey fill-current'
            },
            formatter: function (value, timestamp) {
              return moment(timestamp, 'YYYY-MM-DD').format('DD-MMM-YYYY')
            },
          },
          axisTicks: {
            show: true
          },
          categories: [],
          axisBorder: {
            show: true
          },
          title: {
            text: 'DATE'
          },
        },
        yaxis: {
          title: {
            text: 'ORDERS/QTY (KG)'
          },
          tickAmount: 10,
          labels: {
            style: {
              cssClass: 'text-grey fill-current'
            },
            formatter: function (value, timestamp) {
              return Number(value).toFixed(2)
            },
          }
        },
        tooltip: {
          enabled: true,
          shared: true,
          intersect: false,
          formatter: function (value) {
            return moment(value, 'YYYY-MM-DD').format('DD-MMM-YY')
          },
          custom({series, seriesIndex, dataPointIndex, w}) {
            return '<div style="p-8" class="">' +
              '<span style="font-weight: bold"> DATE : ' + w.globals.labels[dataPointIndex] + '</span> <br>' +
              '<span> QUANTITY : ' + series[seriesIndex][dataPointIndex] + ' (KG)</span> <br>' +
              '<span> ORDERS : ' + window.orders_arr[dataPointIndex] + '</span>' +
              '</div>'
          }
        }
      },
      rmUseQuantityBarChartOptions: {
        grid: {
          borderColor: '#ebebeb',
          padding: {
            left: 0,
            right: 0
          }
        },
        legend: {
          show: true,
        },
        dataLabels: {
          enabled: true,
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ["#ffb921"]
          }
        },
        chart: {
          stacked: true,
          type: 'bar',
          toolbar: { show: false }
        },
        colors: [ '#ffb921', '#ffb921'],
        plotOptions: {
          bar: {
            columnWidth: '25%',
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          }
        },
        xaxis: {
          labels: {
            rotate: -45,
            rotateAlways: true,
            style: {
              cssClass: 'text-grey fill-current'
            },
            formatter: function (value, timestamp) {
              return moment(timestamp, 'YYYY-MM-DD').format('DD-MMM-YY')
            },
          },
          axisTicks: {
            show: false
          },
          categories: [],
          axisBorder: {
            show: true
          },
          title: {
            text: 'DATE'
          },
        },
        yaxis: {
          title: {
            text: 'QUANTITY ORDERED'
          },
          tickAmount: 10,
          labels: {
            style: {
              cssClass: 'text-grey fill-current'
            }
          }
        },
        tooltip: {
          x: { show: false }
        }
      },
      clientRetentionBar: {
        series: [
          {
            name: 'Quantity (kg)',
            data: [],
            arr: ['janaka', 'pradeep']
          }
        ],
      },
    }
  }

export default {
  name: 'PredictedUseGraphPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (data) {
      try {
        await Object.assign(this.$data, initialState())
        this.open = true;
        this.data= data
        await this.chartDataCalculate()
        window.orders_arr = this.orders_arr
      } catch (error) {

      }
    },
    chartDataCalculate() {
      this.rmUseOrderBarChartOptions.xaxis.categories = this.data.history.map((n) => {
        return n.expiry_manu_day
      })
      // this.rmUseQuantityBarChartOptions.xaxis.categories = this.data.history.map((n) => {
      //   return n.expiry_manu_day
      // })
      this.orders_arr = this.data.history.map((n) => {
        return n.orders
      })
      this.clientRetentionBar.series[0].data = this.data.history.map((n) => {
        return n.quantity
      })
      this.isLoaded = true
    },
    test() {

    }
  },
  components: {
    'v-select': vSelect,
    VueApexCharts,
    StatisticsCardLine
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped type="text/css">
  @import url('https://fonts.googleapis.com/css?family=Poppins');
  .predicted-graph-popup >>> .vs-popup {
    /*min-height: 60% !important;*/
    min-width: 70% !important;
  }
  * {
    font-family: 'Poppins', sans-serif;
  }

  #chart {
    max-width: 760px;
    margin: 35px auto;
    opacity: 0.9;
  }

  .arrow_box {
    position: relative;
    background: red;
    border: 2px solid #000000;
  }
  .arrow_box:after, .arrow_box:before {
    right: 100%;
    top: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  .arrow_box:after {
    border-color: rgba(85, 85, 85, 0);
    border-right-color: #555;
    border-width: 10px;
    margin-top: -10px;
  }
  .arrow_box:before {
    border-color: rgba(0, 0, 0, 0);
    border-right-color: #000000;
    border-width: 13px;
    margin-top: -13px;
  }

  #chart .apexcharts-tooltip {
    color: #fff;
    transform: translateX(10px) translateY(10px);
    overflow: visible !important;
    white-space: normal !important;
  }

  #chart .apexcharts-tooltip span {
    padding: 5px 10px;
    display: inline-block;
  }
</style>
